query FileCabinetDocumentTypes {
  fileCabinetDocumentTypes(orderBy: DOCUMENT_TYPE_ASC) {
    nodes {
      id
      documentType
      isAccountingDocument
    }
  }
}
